import { createRequestActionTypes } from '../../helpers'

export const FETCH_BULLETIN = createRequestActionTypes('BULLETIN', 'FETCH')
export const RESET_BULLETIN = 'RESET_BULLETIN'
